import { get } from 'lodash';
import SectionType from 'apps/catalogue/models/SectionType';
import containerTypes from 'apps/analytics/utils/containerTypes';
import getAnalyticsSectionTitle from './getAnalyticsSectionTitle';

/**
 * Generate a product list name for GTM based on page type and section
 *
 * @param {string} pageType Page type value
 * @param {Object} section Catalogue section object
 * @param {Object} section.attributes Catalogue section attributes object
 * @param {SectionType} section.attributes.type Catalogue section type
 * @param {string} section.attributes.title Catalogue section title
 * @param {string} containerType Container type ("Similar products" / "You might also like" / etc.)
 * @returns {string} Product list name, suitable for GTM event reporting
 */
export default function getGTMProductListName(pageType, section, containerType) {
  const sectionType = get(section, 'attributes.type');
  const sectionTitle = getAnalyticsSectionTitle(section, pageType, containerType);
  let productListName = pageType;

  if (
    pageType === 'Search results' &&
    [SectionType.FEATURED, SectionType.FAVOURITES].includes(sectionType)
  ) {
    productListName = `${pageType}: ${sectionTitle}`;
  }

  if (
    ['Back of pack', 'BOP'].includes(pageType) &&
    (
      [SectionType.YOU_MIGHT_LIKE, SectionType.SIMILAR_PRODUCTS].includes(sectionType) ||
      [containerTypes.YOU_MIGHT_LIKE, containerTypes.SIMILAR_PRODUCTS].includes(containerType)
    )
  ) {
    productListName = `${pageType}: ${sectionTitle}`;
  }

  if (
    pageType === 'Catalogue' &&
    [
      SectionType.FEATURED,
      SectionType.OTHER,
      SectionType.FAVOURITES,
      SectionType.ON_OFFER,
      SectionType.NEW,
    ].includes(sectionType)
  ) {
    productListName = `${pageType}: ${sectionTitle}`;
  }

  return productListName;
}
